import { PairsObservable } from './PairsObservable';
export var pairs = PairsObservable.create;
//# sourceMappingURL=pairs.js.map